module.exports = __webpack_public_path__ + "img/map_marker_draggable.5524e8e5.svg";